import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
import { saveAs } from "file-saver";

@Component({
  selector: 'app-grupo-formulario',
  templateUrl: './formulario.component.html'
})

export class FormularioComponent implements OnInit {


    empresa       = localStorage.getItem("empresa");
    sucursal      = localStorage.getItem("sucursal");
    configuracion = JSON.parse(localStorage.getItem("configuracion"));


  dato: FormGroup;
  tieneid;
  tab2 = 0;
  tab = 0;
  form_categorias_materias;
  form_materias;
  tamano = document.body.clientHeight;

  opciones_calificacion = this.fb.group({
    id: [''],
    modalidades_id: ['', [Validators.required]],
    orden: ['', [Validators.required]],
    nombre: ['', [Validators.required]],
    tipo: ['', [Validators.required]]
  });

  tipos_opciones = [
    { id: "ORDINARIO", text: "ORDINARIO" },
    { id: "EXTRAORDINARIO", text: "EXTRAORDINARIO" }
  ];

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder) { }

  ngOnInit() {
    
    this.dato = this.fb.group({
      id: [''],
      activo: ['0', [Validators.required]],
      rvoe: ['', [Validators.required]],
      vigente_desde: ['', [Validators.required]],
      minimo_aprobatorio: ['0', [Validators.required]],
      planes_estudios: this.fb.group({
        nombre: ''
      }),
      carreras: this.fb.group({
        nombre: ''
      }),
      categorias_materias: this.fb.array([]),
      opciones_calificacion: this.fb.array([])
    });

    this.route.params.subscribe(params => {
      this.tieneid = params['id'];
    });

  }

  get categoriasMaterias(): FormArray {
  return this.dato.get('categorias_materias') as FormArray;
}

  agregar_categoria_materia() {
    const categoria = <FormArray>this.dato.controls.categorias_materias;
    categoria.controls.push(this.fb.group({
      id: [''],
      nombre: ['', [Validators.required]],
      materias: this.fb.array([])
    })
    );
  }
  agregar_opcion() {
    const opcion = <FormArray>this.dato.controls.opciones_calificacion;
    opcion.controls.push(this.fb.group({
      id: [''],
      modalidades_id: ['', [Validators.required]],
      orden: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      tipo: ['', [Validators.required]]
    }))
  }
  agregar_materia(i) {
    console.log(i);
    const categoria = <FormArray>this.dato.controls.categorias_materias;
    const ctrl = <FormGroup>categoria.controls[i];
    const materia = <FormArray>ctrl.controls.materias
    materia.controls.push(this.fb.group({
      id: [''],
      nombre: ['', [Validators.required]],
      categorias_id: [''],
      nivel: ['', [Validators.required]],
      clave: ['', [Validators.required]],
      hd: ['', [Validators.required]],
      hi: ['', [Validators.required]],
      materia_anterior: [null],
      creditos: ['', [Validators.required]],
      orden: ['', [Validators.required]],
      id_asignatura: ['', [Validators.required]]
    })
    );
  }






   generarPDF() {

    console.log(" DATO CARRERAS >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
    console.log( this.dato.get('carreras').value );
    console.log(" FIN DATO CARRERAS >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");

    const carrera      = this.dato.get('carreras').value;
    const plan_estudio = this.dato.get('planes_estudios').value;

    console.log(" DATO CARRERA en object >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
    console.log( carrera);
    console.log(" FIN DATO CARRERA en object >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");

const materias: any[] = [];
const categorias: any[] = [];
    this.categoriasMaterias.controls.forEach((control, i) => {
      categorias.push(control.value);
     // console.log(`Categoría ${i}:`, control.value);
    });

categorias.forEach(categoria => {
  if (Array.isArray(categoria.materias)) {
    categoria.materias.forEach(materia => {  
      materias.push({
        ...materia,
        categoria: { ...categoria, materias: undefined } // evita incluir el array entero
      });
    });
  }
});

console.log(materias);

    function toNumber(value: any): number {
  const n = Number(value);
  return isNaN(n) ? 0 : n;
}

materias.sort((a, b) => {
  const nivelA = toNumber(a.nivel);
  const nivelB = toNumber(b.nivel);

  if (nivelA !== nivelB) {
    return nivelA - nivelB;
  }

  const ordenA = toNumber(a.orden);
  const ordenB = toNumber(b.orden);

  return ordenA - ordenB;
});

console.log(materias);


   const data = materias;


  //const doc = new jsPDF();
  //const doc = new jsPDF('l', 'mm', [297, 210]); // Orientación landscape, mm, tamaño A4 (210x297 mm)
  const doc = new jsPDF({
  orientation: 'landscape',
  unit: 'mm',
  format: 'a4'
});

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const margin = 15;
  const lineHeight = 7;
  const rowHeight = 9;

  // Encabezados individuales (puedes modificar estos valores)
  const encabezado1 = ""+this.configuracion.empresa.nombre;
  const encabezado2 = "CAMPUS "+this.configuracion.sucursal.nombre.toUpperCase();
  const encabezado3 = ""+carrera.nombre+'. RVOE '+carrera.rvoe;
  const encabezado4 = ""+plan_estudio.nombre+', VIGENTE '+this.dato.get('vigente_desde').value;

  const columnTitles = ["NIVEL", "ORDEN", "CLAVE", "NOMBRE", "AREA DE FORMACION", "CRÉDITOS", "HD", "HI"];
  const columnWidths = [15, 15, 25,110, 60, 20,15, 15];

  let y = margin + 4 * lineHeight + 5;
  let currentPage = 1;
  let totalPages = 1;

  const rowsPerPage = Math.floor((pageHeight - y - 20) / rowHeight);
  totalPages = Math.ceil(data.length / rowsPerPage);

  function drawHeader(doc, pageNumber) {
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");

    doc.text(encabezado1, margin, margin + lineHeight * 0);
    doc.text(encabezado2, margin, margin + lineHeight * 1);
    doc.text(encabezado3, margin, margin + lineHeight * 2);
    doc.text(encabezado4, margin, margin + lineHeight * 3);

    // Encabezado de columnas
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    let x = margin;
    let headerY = margin + 4 * lineHeight + 2;
    for (let i = 0; i < columnTitles.length; i++) {
      doc.text(columnTitles[i], x, headerY);
      x += columnWidths[i];
    }
  }

  function drawFooter(doc, pageNumber, totalPages)
  {
    const now = new Date();
    const fechaHora = now.toLocaleString();
    

    const footerText = `Pag. ${pageNumber} de ${totalPages}`;
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    doc.text(fechaHora+" Manager Escolar v1.1", margin, pageHeight - 10);
    doc.text(footerText, pageWidth - margin - doc.getTextWidth(footerText), pageHeight - 10);
  }

  let itemIndex = 0;
  for (let page = 1; page <= totalPages; page++)
    {
      if (page > 1) doc.addPage();
      drawHeader(doc, page);
      drawFooter(doc, page, totalPages);

      let startY = margin + 4 * lineHeight + 8;
      for (let row = 0; row < rowsPerPage && itemIndex < data.length; row++, itemIndex++)
      {
        const item = data[itemIndex];
        let x = margin;
        let rowY = startY + row * rowHeight;

        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");

        const rowData = [
          item.nivel || "",
          item.orden || "",
          item.clave || "",
          item.nombre || "",
          item.categoria.nombre || "NO DISPONIBLE",
          item.creditos || 0,
          item.hd || 0 ,
          item.hi || 0
        ];

        for (let col = 0; col < rowData.length; col++)
          {
            doc.text(String(rowData[col]), x, rowY, { maxWidth: 100 });
            x += columnWidths[col];
          }
      }
    }

  doc.save("PLAN_ESTUDIOS_"+carrera.sigla+"_"+carrera.rvoe+".pdf");
} /// FIN FUNCION PDF IMPRIMIR









}
